import { fetchSelfTickets } from '../fetch/fetchSelfTickets.js';
import { formatEventTime } from '../utils/formatEventTime.js';

export async function displayUserSelfTickets(eventBucketId, privatApiKey, userToken) {
  const selfTicketsButton = document.querySelectorAll('.self_tickets');

  // return if no self ticket buttons stored on the page.
  if (selfTicketsButton.length <= 0 || !userToken || !privatApiKey || !eventBucketId) {
    return;
  }

  /** @type UserSelfTickets selfTickets */
  const selfTickets = await fetchSelfTickets(userToken, eventBucketId, privatApiKey);
  // return if no self tickets or empty self tickets ([]).
  if (!selfTickets || selfTickets.tickets.length <= 0) {
    return;
  }

  // console.trace({ selfTickets: selfTickets });

  selfTicketsButton.forEach(button => {
    const eventId = button.getAttribute('data-selftickets');

    // Filtere die Tickets basierend auf der eventId
    const ticketsForEvent = selfTickets.tickets.filter(ticket => ticket.event.id === eventId);

    if (ticketsForEvent.length > 0) {
      // Zeige die Anzahl der gekauften Tickets an
      button.querySelector('.self_ticket_count').textContent = `${ticketsForEvent.length}`;
      button.style.display = 'block';

      // Check whether an event listener already exists
      if (!button.hasAttribute('data-listener')) {
        // Event-Listener für den Klick auf den Button hinzufügen
        button.addEventListener('click', function () {
          const sliderModalContent = document.getElementById('gd__checkout__self__tickets__slider');
          const eventModal = document.getElementById('gd__checkout__container');

          // Remove previous slider container content
          sliderModalContent.innerHTML = '';

          const sliderHeader = document.createElement('div');
          sliderHeader.classList.add('qr-slider--header');
          // event name.
          const eventNameElement = document.createElement('h2');
          eventNameElement.textContent = ticketsForEvent[0]?.event?.name && ticketsForEvent[0].event.name;
          // venue name.
          const venueNameElement = document.createElement('h3');
          venueNameElement.textContent = ticketsForEvent[0]?.event?.venue?.name && ticketsForEvent[0]?.event.venue.name;
          // Event start_time
          const eventStartTime = document.createElement('div');
          eventStartTime.classList.add('qr-slider--start--time');
          eventStartTime.textContent = ticketsForEvent[0]?.event?.start_time && formatEventTime(ticketsForEvent[0].event.start_time);

          sliderHeader.appendChild(eventNameElement);
          sliderHeader.appendChild(venueNameElement);
          sliderHeader.appendChild(eventStartTime);
          sliderModalContent.appendChild(sliderHeader);

          // Slider-Container
          const sliderContainer = document.createElement('div');
          sliderContainer.classList.add('qr-slider');

          // Tickets
          ticketsForEvent.forEach((ticket, index) => {

            if (ticket?.qr_code_path) {
              // Erstelle ein div als Container für das Bild und zusätzliche Infos
              const ticketContainer = document.createElement('div');
              ticketContainer.classList.add('ticket-info-container');

              // QR Code image
              const img = document.createElement('img');
              img.src = `https://api.eventive.org/${ticket.qr_code_path}`;
              img.alt = `QR Code for Ticket ${ticket?.id}`;

              // Ticket detail container
              const ticketDetails = document.createElement('div');
              ticketDetails.classList.add('ticket--details');
              // Ticket ID
              const ticketIdInfo = document.createElement('div');
              ticketIdInfo.innerHTML = ticket?.id && `<span class="label">Ticket:</span> ${ticket.id}`;

              // Ticket Type
              const ticketType = document.createElement('div');
              ticketType.innerHTML = ticket?.ticket_bucket?.name && `<span class="label">Type:</span> ${ticket.ticket_bucket.name}`;

              // Ticket order at
              const ticketOrdered = document.createElement('div');
              ticketOrdered.innerHTML = ticket?.created_at && `<span class="label">Ordered:</span> ${formatEventTime(ticket.created_at)}`;

              // ticket quantity counter
              const pageNumber = document.createElement('div');
              pageNumber.innerHTML = `${index + 1}/${ticketsForEvent.length}`;

              // Füge Bild und Infos in das div hinzu
              ticketContainer.appendChild(img);
              ticketContainer.appendChild(ticketDetails);
              ticketDetails.appendChild(ticketIdInfo);
              ticketDetails.appendChild(ticketType);
              ticketDetails.appendChild(ticketOrdered);
              ticketDetails.appendChild(pageNumber);

              // Füge den Container in den Slider hinzu
              sliderContainer.appendChild(ticketContainer);
            }
          });

          if (eventModal && sliderModalContent) {
            eventModal.style.display = 'block';
            sliderModalContent.appendChild(sliderContainer);

            // init slick slider with tickets images and infos.
            initializeSlider(500);
          }
        });

        // Mark the button that a listener has been added.
        button.setAttribute('data-listener', 'true');
      }
    }
  });
}

function initializeSlider(timeout) {
  const sliderContainer = document.querySelector('.qr-slider');
  if (sliderContainer) {
    // Check whether the slider has already been initialized and remove it if necessary.
    if (jQuery(sliderContainer).hasClass('slick-initialized')) {
      jQuery(sliderContainer).slick('unslick');
    }
    window.setTimeout(() => {
      jQuery(sliderContainer).slick({
        dots: false,
        infinite: false,  // Infinite must be set to false to monitor state
        speed: 100,
        fade: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: "<div class=\"prev\"><span class=\"icon-left\"></span></div>",
        nextArrow: "<div class=\"next\"><span class=\"icon-right\"></span></div>",
      });

      const prevArrow = jQuery('.prev');
      const nextArrow = jQuery('.next');

      // monitor the afterChange slider event
      jQuery(sliderContainer).on('afterChange', function (event, slick, currentSlide) {
        // Disable prevArrow when the first image is reached
        if (currentSlide === 0) {
          prevArrow.addClass('disabled');
        } else {
          prevArrow.removeClass('disabled');
        }

        // Disable nextArrow when the last frame is reached
        if (currentSlide === slick.slideCount - 1) {
          nextArrow.addClass('disabled');
        } else {
          nextArrow.removeClass('disabled');
        }
      });

      // Initialize the disabled classes based on the startup state
      const initialSlide = jQuery(sliderContainer).slick('slickCurrentSlide');
      const slideCount = jQuery(sliderContainer).slick('getSlick').slideCount;

      if (initialSlide === 0) {
        prevArrow.addClass('disabled');
      }
      if (initialSlide === slideCount - 1) {
        nextArrow.addClass('disabled');
      }
    }, timeout);
  }
}

